import React from 'react'
import "../styles/Mission.css"

const Mission = () => {
    return (
        <div id='mission'>
            <section className='mission-main'>
                <h1 className='mish1'>OUR MISSION AND MY STANDS FOR</h1>
                <p className='misp'>“COMMITTED TO EQUALITY,DEDICATED TO PROSPERITY”</p>
                <p className='misp1'>is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a  type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software
                    like Aldus PageMaker including versions of Lorem Ipsum</p>
                <div className='miscardmain'>
                    <div className='miscard'>
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                    <div className='miscard'>
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                    <div className='miscard'>
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                    <div className='miscard'>
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                </div>
            </section>

            <section className="connect-section">
                <div className="connect-overlay"></div>

                <div className="connect-card">
                    {/* LEFT CONTENT */}
                    <div className="connect-left">
                        <h2>CONNECT WITH US!</h2>

                        <p>
                            IS SIMPLY DUMMY TEXT OF THE PRINTING AND TYPESETTING INDUSTRY.
                            LOREM IPSUM HAS BEEN THE INDUSTRY’S STANDARD DUMMY TEXT EVER
                        </p>

                        <input
                            type="email"
                            placeholder="EMAIL ADDRESS"
                            className="connect-input"
                        />

                        <button className="connect-btn">CONNECT</button>

                        <div className="social-icons">
                            <span className="facebook">f</span>
                            <span className="instagram">📸</span>
                            <span className="twitter">𝕏</span>
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="connect-right">
                        <img
                            src="/assets/tvkimages/image 10.png"
                            alt="Connect"
                        />
                    </div>
                </div>
            </section>

            <section className='mission-main'>
                <h1 className='mish1'>UPDATED NEWS & EVENTS </h1>
                <p className='misp'>“STAY INFORMED, STAY INVOLVED, YOUR SOURCE FOR PARTY
                    UPDATES AND EVENTS!”</p>
                <p className='misp1'>is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a  type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software
                    like Aldus PageMaker including versions of Lorem Ipsum</p>
                <div className='miscardmain'>
                    <div className='miscard'>
                        <img className='misimagehead' src="/assets/tvkimages/image 12.png" alt="" />
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                    <div className='miscard'>
                        <img className='misimagehead' src="/assets/tvkimages/image 13.png" alt="" />
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                    <div className='miscard'>
                        <img className='misimagehead' src="/assets/tvkimages/image 14.png" alt="" />
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                    <div className='miscard'>
                        <img className='misimagehead' src="/assets/tvkimages/image 15.png" alt="" />
                        <h1 className='miscardh1'>lorem</h1>
                        <p className='miscardp'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                        <img className='misimage' src="/assets/tvkimages/line.png" alt="" />
                    </div>
                </div>
            </section>

            <section className='mission-main'>
                <h1 className='mish1'>OUR SERVICES</h1>
                <p className='misp'>"OUR SERVICES ARE DESIGNED TO ADDRESS THE DIVERSE NEEDS
                    OF OUR COMMUNITIES AND TO CREATE A THRIVING, EQUITABLE STATE.
                    HERE AN OVERVIEW OF THE KEY SERVICES”</p>
                <img className='servimage' src="/assets/tvkimages/image 16.png" alt="" />
            </section>
        </div>
    )
}

export default Mission